import { Button, Table } from 'antd';
import {
  IServicePermissionsObjectItem,
  IServicePermissionsGroupItem,
  IServicePermissionsObjectTableItem,
} from '../../../../model/rbac';
import getFormatMessage from '../../../../locales/get-format-message';
import { useState } from 'react';

interface IProps {
  readonly getObjectList: () => void;
  readonly loading: boolean;
  readonly objectList: IServicePermissionsObjectItem[] | [];
  readonly onEdit: (record: IServicePermissionsObjectTableItem) => void;
  readonly onDel: (record: IServicePermissionsObjectTableItem) => void;
  readonly groupList: IServicePermissionsGroupItem[];
}

export const ObjectTable = (props: IProps) => {
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);

  const renderDefaultOperate = (
    record: IServicePermissionsObjectTableItem,
    onEdit: (record: IServicePermissionsObjectTableItem) => void,
    onDel: (record: IServicePermissionsObjectTableItem) => void
  ): React.ReactNode => {
    return (
      <div>
        <Button
          className="ant-btn ant-btn-default gc-btn gc-btn-primary btn-admin is-small"
          onClick={() => onEdit(record)}
        >
          {getFormatMessage('edit')}
        </Button>
        <Button
          className="ant-btn ant-btn-primary ant-btn-sm ant-btn-dangerous btn-admin"
          style={{ marginLeft: '2px' }}
          onClick={() => onDel(record)}
        >
          {getFormatMessage('delete')}
        </Button>
      </div>
    );
  };
  const findChildren = (parentId: number) => {
    const groupChild = props.groupList.filter(
      (item) => item.parentId === parentId
    );
    const newChildren: IServicePermissionsObjectTableItem[] = [];
    groupChild.forEach((child) => {
      const groupChildren = findChildren(child.objectGroupId);
      const objectChildren = props.objectList.filter((item) => {
        if (item.objectGroupId === child.objectGroupId) {
          return {
            ...item,
            key: `${item.objectKey}${item.objectId}`,
          };
        }
        return false;
      });
      const currentChildren = groupChildren.concat(objectChildren);
      newChildren.push({
        ...child,
        key: `${child.objectGroupName}${child.objectGroupId}`,
        children: currentChildren.length === 0 ? null : currentChildren,
      });
    });
    return newChildren;
  };

  const getGroupTree = () => {
    const rootNodes = findChildren(0);
    return rootNodes || [];
  };

  // 获取所有节点的 key
  const getAllKeys = (data: IServicePermissionsObjectTableItem[]) => {
    const keys: React.Key[] = [];
    const traverse = (nodes: IServicePermissionsObjectTableItem[]) => {
      nodes.forEach((node) => {
        if (node.key) keys.push(node.key);
        if (node.children) traverse(node.children);
      });
    };
    traverse(data);
    return keys;
  };

  // 一键展开所有行
  const expandAll = () => {
    setExpandedRowKeys(getAllKeys(getGroupTree()));
  };

  // 一键折叠所有行
  const collapseAll = () => {
    setExpandedRowKeys([]);
  };

  const columns = [
    {
      title: getFormatMessage('objectGroupId'),
      dataIndex: 'objectGroupId',
      key: 'objectGroupId',
      width: 160,
      render: (_value: number, record: IServicePermissionsObjectTableItem) => {
        if (!record?.children && record?.objectId) {
          return '';
        }
        return _value;
      },
    },
    {
      title: getFormatMessage('objectGroupName'),
      dataIndex: 'objectGroupId',
      key: 'objectGroupName',
      width: 220,
      render: (_value: number, record: IServicePermissionsObjectTableItem) => {
        if (!record?.children && record?.objectId) {
          return '';
        }
        const objectItem = props.groupList.find(
          (item) => item.objectGroupId === _value
        );
        if (objectItem?.objectGroupName) {
          return objectItem.objectGroupName;
        }
      },
    },
    {
      title: getFormatMessage('objectId'),
      dataIndex: 'objectId',
      key: 'objectId',
      width: 150,
    },
    {
      title: getFormatMessage('objectKey'),
      dataIndex: 'objectKey',
      key: 'objectKey',
      width: 250,
    },
    {
      title: getFormatMessage('objectName'),
      dataIndex: 'objectName',
      key: 'objectName',
      width: 250,
    },
    {
      title: getFormatMessage('operate'),
      key: 'action',
      minWidth: 150,
      render: (_text: string, record: IServicePermissionsObjectTableItem) => {
        if (!record?.children && record?.objectId) {
          return renderDefaultOperate(record, props.onEdit, props.onDel);
        }
        return null;
      },
    },
  ];

  return (
    <>
      <Button onClick={expandAll} style={{ marginBottom: 16 }}>
        {getFormatMessage('expand_all')}
      </Button>
      <Button onClick={collapseAll} style={{ marginLeft: 8, marginBottom: 16 }}>
        {getFormatMessage('put_away_all')}
      </Button>
      <Table
        rowKey="key"
        className="object-table"
        loading={props.loading}
        dataSource={getGroupTree() || []}
        expandable={{
          expandedRowKeys,
          onExpand: (expanded, record) => {
            setExpandedRowKeys((prevKeys) => {
              if (expanded) {
                return [...prevKeys, record.key].filter(
                  (key): key is React.Key => key !== undefined
                );
              } 
                return prevKeys.filter((key) => key !== record.key);
              
            });
          },
        }}
        columns={columns}
        pagination={false}
      />
    </>
  );
};
